// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.perxis-auto-1_16_13-parameters {
  /* Typography */
  --perxis-auto-parameters-font-family-inner: var(
    --perxis-auto-parameters-font-family,
    var(--perxis-auto-root-typography-h5-font-family-inner)
  );
  --perxis-auto-parameters-font-size-inner: var(
    --perxis-auto-parameters-font-size,
    var(--perxis-auto-root-typography-h5-font-size-xxl-inner)
  );
  --perxis-auto-parameters-font-weight-inner: var(
    --perxis-auto-parameters-font-weight,
    var(--perxis-auto-root-typography-h5-font-weight-inner)
  );
  --perxis-auto-parameters-letter-spacing-inner: var(
    --perxis-auto-parameters-letter-spacing,
    var(--perxis-auto-root-typography-h5-letter-spacing-inner)
  );
  --perxis-auto-parameters-line-height-inner: var(
    --perxis-auto-parameters-line-height,
    var(--perxis-auto-root-typography-h5-line-height-xxl-inner)
  );
  --perxis-auto-parameters-text-transform-inner: var(
    --perxis-auto-parameters-text-transform,
    var(--perxis-auto-root-typography-h5-text-transform-inner)
  );
  --perxis-auto-parameters-panel-color-inner: var(
    --perxis-auto-parameters-panel-color,
    var(--perxis-auto-root-typography-color-dark-inner)
  );
  --perxis-auto-parameters-header-color-inner: var(
    --perxis-auto-parameters-header-color,
    var(--perxis-auto-root-typography-color-darkest-inner)
  );
  --perxis-auto-parameters-arrow-color-inner: var(
    --perxis-auto-parameters-arrow-color,
    var(--perxis-auto-root-typography-color-dark-inner)
  );
  --perxis-auto-parameters-active-arrow-color-inner: var(
    --perxis-auto-parameters-active-arrow-color,
    var(--perxis-auto-parameters-arrow-color-inner)
  );
  /* End Typography */
  /* Padding */
  --perxis-auto-parameters-padding-inner: var(--perxis-auto-parameters-padding, 0 18px 0 18px);
  /* End Padding */
  /* Scrollbar */
  --perxis-auto-parameters-scrollbar-width-inner: var(--perxis-auto-parameters-scrollbar-width, 8px);
  --perxis-auto-parameters-scrollbar-track-background-color-inner: var(
    --perxis-auto-parameters-scrollbar-track-background-color,
    transparent
  );
  --perxis-auto-parameters-scrollbar-thumb-background-color-inner: var(
    --perxis-auto-parameters-scrollbar-thumb-background-color,
    var(--perxis-auto-root-sixth-color-inner)
  );
  --perxis-auto-parameters-scrollbar-thumb-border-radius-inner: var(
    --perxis-auto-parameters-scrollbar-thumb-border-radius,
    5px
  );
  /* End Scrollbar */
}
.perxis-auto-1_16_13-parameters {
  height: fit-content;
  max-height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  scrollbar-gutter: stable;
  scrollbar-color: var(--perxis-auto-parameters-scrollbar-thumb-background-color-inner);
}
.perxis-auto-1_16_13-parameters::-webkit-scrollbar {
  width: var(--perxis-auto-parameters-scrollbar-width-inner);
}
.perxis-auto-1_16_13-parameters::-webkit-scrollbar-track {
  background: var(--perxis-auto-parameters-scrollbar-track-background-color-inner);
}
.perxis-auto-1_16_13-parameters::-webkit-scrollbar-thumb {
  background-color: var(--perxis-auto-parameters-scrollbar-thumb-background-color-inner);
  border-radius: var(--perxis-auto-parameters-scrollbar-thumb-border-radius-inner);
}
.perxis-auto-1_16_13-parameters .perxis-auto-1_16_13-parameters__body {
  --perxis-auto-collapse-panel-color: var(--perxis-auto-parameters-panel-color-inner);
  --perxis-auto-collapse-header-color: var(--perxis-auto-parameters-header-color-inner);
  --perxis-auto-collapse-arrow-color: var(--perxis-auto-parameters-arrow-color-inner);
  --perxis-auto-collapse-active-arrow-color: var(--perxis-auto-parameters-active-arrow-color-inner);
  --perxis-auto-collapse-font-family: var(--perxis-auto-parameters-font-family-inner);
  --perxis-auto-collapse-font-size: var(--perxis-auto-parameters-font-size-inner);
  --perxis-auto-collapse-font-size-xxs-xs: var(--perxis-auto-parameters-font-size-inner);
  --perxis-auto-collapse-font-size-sm-xxl: var(--perxis-auto-parameters-font-size-inner);
  --perxis-auto-collapse-line-height: var(--perxis-auto-parameters-line-height-inner);
  --perxis-auto-collapse-font-weight: var(--perxis-auto-parameters-font-weight-inner);
  --perxis-auto-collapse-text-transform: var(--perxis-auto-parameters-text-transform-inner);
  --perxis-auto-collapse-letter-spacing: var(--perxis-auto-parameters-letter-spacing-inner);
}
.perxis-auto-1_16_13-parameters .perxis-auto-1_16_13-parameters__header,
.perxis-auto-1_16_13-parameters .perxis-auto-1_16_13-parameters__footer {
  padding: var(--perxis-auto-parameters-padding-inner);
}
.perxis-auto-1_16_13-parameters .perxis-auto-1_16_13-parameters__skeleton.ant-5_17_0-skeleton .ant-5_17_0-skeleton-content .ant-5_17_0-skeleton-paragraph {
  margin: 0;
}
.perxis-auto-1_16_13-parameters .perxis-auto-1_16_13-parameters__skeleton.ant-5_17_0-skeleton .ant-5_17_0-skeleton-content .ant-5_17_0-skeleton-paragraph > li {
  height: 24px;
}
.perxis-auto-1_16_13-parameters .perxis-auto-1_16_13-parameters__skeleton.ant-5_17_0-skeleton .ant-5_17_0-skeleton-content .ant-5_17_0-skeleton-paragraph > li + li {
  margin-block-start: var(--perxis-auto-gap-vertical-purple-inner);
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
